import script from "./forgot-second.vue?vue&type=script&setup=true&lang=js"
export * from "./forgot-second.vue?vue&type=script&setup=true&lang=js"

import "./forgot-second.vue?vue&type=style&index=0&id=6975d3d0&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6975d3d0"]])

export default __exports__